import { useLanguage } from "../../../i18n/LanguageContext";
import "./dnd.css";

const text = {
    en: {
        app: "Smart Key · Room 214",
        greeting: "Good evening",
        dnd: "Do Not Disturb",
        off: "Off",
        on: "On · staff notified",
        roomKey: "Room key",
        swipe: "Swipe to open",
        services: "Services",
        askAnything: "Ask for anything",
        console: "Housekeeping · Today",
        live: "Live",
        cleaned: "Cleaned",
        done: "✓ Done",
        cleaningNow: "Cleaning now",
        inProgress: "In progress",
        at1100: "Scheduled 11:00",
        at1130: "Scheduled 11:30",
        at1200: "Scheduled 12:00",
        next: "Next",
        skip: "Skip",
        queued: "Queued",
        toast: "Room 214 is now Do Not Disturb",
    },
    ar: {
        app: "ضياف · الغرفة 214",
        greeting: "مساء الخير",
        dnd: "عدم الإزعاج",
        off: "متوقف",
        on: "مفعّل · تم إبلاغ الفريق",
        roomKey: "مفتاح الغرفة",
        swipe: "مرّر للفتح",
        services: "الخدمات",
        askAnything: "اطلب ما تحتاجه",
        console: "التدبير المنزلي · اليوم",
        live: "مباشر",
        cleaned: "تم التنظيف",
        done: "✓ تم",
        cleaningNow: "جارٍ التنظيف",
        inProgress: "قيد التنفيذ",
        at1100: "مجدول 11:00",
        at1130: "مجدول 11:30",
        at1200: "مجدول 12:00",
        next: "التالي",
        skip: "تخطٍّ",
        queued: "في الانتظار",
        toast: "الغرفة 214 في وضع عدم الإزعاج",
    },
};

const moon = <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />;

// Guest taps Do Not Disturb -> housekeeping console marks the room to skip. One 7s loop.
const DndScene = () => {
    const { lang, isRtl } = useLanguage();
    const t = text[lang];
    const dir = isRtl ? "rtl" : "ltr";
    return (
        <>
            <div className="skn-backdrop"></div>
            <div className="skn-glow"></div>

            <div className="sk-mobile skn-phone">
                <div className="sk-mobile-screen" dir={dir}>
                    <div className="skn-tint"></div>
                    <div className="sk-mobile-label">{t.app}</div>
                    <div className="sk-mobile-heading">{t.greeting}</div>

                    <div className="skn-card skn-dnd">
                        <span className="skn-icon">
                            <svg viewBox="0 0 24 24" fill="#7c6cff">{moon}</svg>
                        </span>
                        <span className="skn-text">
                            <b>{t.dnd}</b>
                            <span className="skn-sub">
                                <span className="off">{t.off}</span>
                                <span className="on">{t.on}</span>
                            </span>
                        </span>
                        <span className="skn-toggle"><i></i></span>
                        <span className="skn-tap"></span>
                    </div>

                    <div className="skn-card skn-muted">
                        <span className="skn-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#0b5f8f" strokeWidth="2" strokeLinecap="round">
                                <circle cx="7.5" cy="15.5" r="4.5" /><path d="M10.7 12.3 21 2M16 7l3 3" />
                            </svg>
                        </span>
                        <span className="skn-text"><b>{t.roomKey}</b><span className="skn-sub">{t.swipe}</span></span>
                    </div>

                    <div className="skn-card skn-muted">
                        <span className="skn-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#0b5f8f" strokeWidth="2" strokeLinecap="round">
                                <path d="M3.5 18.5h17M5.5 18.5a6.5 6.5 0 0 1 13 0M12 9.5V7.5M10 7.5h4" />
                            </svg>
                        </span>
                        <span className="skn-text"><b>{t.services}</b><span className="skn-sub">{t.askAnything}</span></span>
                    </div>
                </div>
            </div>

            <div className="sk-panel skn-console" dir={dir}>
                <div className="sk-panel-title">{t.console} <b>{t.live}</b></div>
                <div className="skn-row"><strong>212</strong><span>{t.cleaned}</span><span className="sk-pill skn-green">{t.done}</span></div>
                <div className="skn-row"><strong>213</strong><span>{t.cleaningNow}</span><span className="sk-pill skn-blue">{t.inProgress}</span></div>
                <div className="skn-row skn-target">
                    <strong>214</strong>
                    <span className="skn-swap">
                        <span className="before">{t.at1100}</span>
                        <span className="after">{t.dnd}</span>
                    </span>
                    <span className="skn-swap skn-swap-pill">
                        <span className="before sk-pill skn-grey">{t.next}</span>
                        <span className="after sk-pill skn-indigo">
                            <svg viewBox="0 0 24 24" fill="currentColor">{moon}</svg>{t.skip}
                        </span>
                    </span>
                </div>
                <div className="skn-row"><strong>215</strong><span>{t.at1130}</span><span className="sk-pill skn-grey">{t.queued}</span></div>
                <div className="skn-row"><strong>216</strong><span>{t.at1200}</span><span className="sk-pill skn-grey">{t.queued}</span></div>
            </div>

            <div className="skn-toast" dir={dir}>
                <svg viewBox="0 0 24 24" fill="#a99bff">{moon}</svg>
                {t.toast}
            </div>
        </>
    )
}
export default DndScene;
